import { profileConstants } from '../constants';
import { profileService } from '../services';
import { showToast } from '../services/toast';

export const profileActions = {
    fetchMyprofile,
    updateProfileAvatar,
    updateMyprofile,
    fetchMypoints,
    fetchScoreBoard,
    purchaseProfileAvatar,
    hideAwardPopup,
    updateMypointsFromSocket,
    resetAwardFlags
};

function fetchMyprofile(studentId) {
    return dispatch => {
        dispatch(request());

        return profileService.fetchMyprofile(studentId)
            .then(
                profile => {
                    dispatch(success(profile));
                    return profile;
                },
                error => {
                    dispatch(failure(error));
                    // showToast(error.toString(), 'error');
                }
            );
    };

    function request() { return { type: profileConstants.FETCH_MYPROFILE_REQUEST } }
    function success(profile) { return { type: profileConstants.FETCH_MYPROFILE_SUCCESS, profile } }
    function failure(error) { return { type: profileConstants.FETCH_MYPROFILE_FAILURE, error } }
}

function updateProfileAvatar(avatarDetails) {
    return dispatch => {
        return profileService.updateProfileAvatar(avatarDetails)
            .then(
                response => {
                    return response;
                },
                error => {
                    throw error;
                }
            );
    };
}

function updateMyprofile(profileData) {
    return dispatch => {
        dispatch(request());

        return profileService.updateMyprofile(profileData)
            .then(
                response => {
                    dispatch(success(profileData));
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    showToast(error.toString(), 'error');
                }
            );
    };

    function request() { return { type: profileConstants.UPDATE_MYPROFILE_REQUEST } }
    function success(profile) { return { type: profileConstants.UPDATE_MYPROFILE_SUCCESS, profile } }
    function failure(error) { return { type: profileConstants.UPDATE_MYPROFILE_FAILURE, error } }
}

function fetchMypoints(studentId, isGameSubmit) {
    return dispatch => {
        dispatch(request());

        return profileService.fetchMypoints(studentId, isGameSubmit)
            .then(
                response => {
                    dispatch(success(response));
                    if (response?.IsAwarded === 'Y') {
                        dispatch(showAwardPopup(response.AwardFlagMessages));
                    }
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    // showToast(error.toString(), 'error');
                }
            );
    };

    function request() { return { type: profileConstants.FETCH_MYPOINTS_REQUEST } }
    function success(points) { return { type: profileConstants.FETCH_MYPOINTS_SUCCESS, points } }
    function failure(error) { return { type: profileConstants.FETCH_MYPOINTS_FAILURE, error } }
    function showAwardPopup(message) {
        return {
            type: profileConstants.SHOW_AWARD_POPUP,
            message
        };
    }
}

function updateMypointsFromSocket(points) {
    return {
        type: profileConstants.UPDATE_MYPOINTS_FROM_SOCKET,
        points
    };
}
function resetAwardFlags() {
    return {
        type: profileConstants.RESET_AWARD_FLAGS
    };
}

function fetchScoreBoard(classId) {
    return dispatch => {

        return profileService.fetchScoreBoard(classId)
            .then(
                response => {
                    return response;
                },
                error => {
                    // showToast(error.toString(), 'error');
                    return error;
                }
            );
    };
}

function purchaseProfileAvatar(payload) {
    return dispatch => {

        return profileService.purchaseProfileAvatar(payload)
            .then(
                response => {
                    return response;
                },
                error => {
                    throw error;
                }
            );
    };
}

function hideAwardPopup() {
    return {
        type: profileConstants.HIDE_AWARD_POPUP
    };
}
